import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  ConfirmationDialogComponent,
  ConfirmationDialogData,
  ConfirmationDialogResult,
} from '../global-components/confirmation-dialog/confirmation-dialog.component';


@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {

  constructor(protected dialog: MatDialog) { }

  public open(data: ConfirmationDialogData): Observable<boolean | ConfirmationDialogResult> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '450px',
      data: data,
      panelClass: 'modern-dialog'
    });

    return dialogRef.afterClosed();
  }
}
